import React from "react";
import "./AboutUs.css";
import img2 from "./img/5618.jpg";
import img1 from "./img/8979.jpg";
import img3 from "./img/little-girl-sitting-table-using-modern-tablet.jpg";

export default function AboutUs() {
  return (
    <div className="about-wrapper">
      {/* Left Side Images */}
      <div className="about-images">
        <img src={img1} alt="Vertical Academy" className="img img1" />
        <div className="right-images">
          <img src={img2} alt="Horizontal Academy 1" className="img img2" />
          <img src={img3} alt="Horizontal Academy 2" className="img img3" />
        </div>
      </div>

      {/* Right Side Content */}
      <div className="about-content">
        <h2>About Us</h2>
        <h3 className="about-subtitle">
          <span className="highlight1">Skills at Your Own</span> <br />
          <span className="highlight2">Pace and Location</span>
        </h3>
        <p>
          <b>EduTechMaster Academy</b> is a pioneering online education platform
          committed to empowering learners worldwide. With a steadfast vision to
          transform the landscape of education, we offer an extensive array of
          courses that encompass technology, arts, business, and beyond.
        </p>
        <p>
          Our team of seasoned instructors, who are experts in their respective
          fields, wholeheartedly dedicate themselves to provide comprehensive
          guidance throughout your educational journey. We are devoted to
          fostering the ambitions of our students and facilitating their path
          towards remarkable achievements.
        </p>
        <p>
          Join us and be part of a learning community that thrives on
          innovation, excellence, and limitless possibilities.
        </p>
      </div>
    </div>
  );
}
